import images from 'assets/img'
import React from 'react'
import { withTranslation } from 'react-i18next'

export default withTranslation()(function EmptyVault({ t }) {
  return (
    <div className="w-full h-72 bg-white flex rounded-xl flex-col">
      <div className="w-full text-center m-auto">
        <div className="h-20 w-20 rounded-full bg-default m-auto flex mb-4">
          <img src={ images.Vault } alt="" className="w-10 h-10 m-auto" />
        </div>
        <p className="top-5 text-secondary text-sm">{ t('redemption.empty') }</p>
      </div>
    </div>
  )
})
